export default __webpack_public_path__ + "static/media/doge rose.b772d919.png";